import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import api from '../lib/axios';
import { Card, CardContent } from '../components/ui/Card';
import Button from '../components/ui/Button';
import { Loader2, AlertCircle } from 'lucide-react';

// Public entry point for the link on the company website. Provisions a fresh
// assessment + access token, then hands off to the exact same questionnaire
// journey a client receives via an advisor link.
const PublicStart = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [error, setError] = useState('');
  const startedRef = useRef(false);

  const start = async () => {
    if (startedRef.current) return;
    startedRef.current = true;
    setError('');
    try {
      const res = await api.post('/assessments/public-start');
      const { id, token } = res.data;
      localStorage.setItem('assessmentToken', token);
      navigate(`/assessment/${id}/welcome`);
    } catch (err) {
      startedRef.current = false;
      setError(err.response?.data?.error || 'Unable to start the assessment. Please try again.');
    }
  };

  useEffect(() => {
    start();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: theme.surface }}>
      <div className="max-w-md w-full">
        {error ? (
          <Card>
            <CardContent className="pt-6">
              <div className="text-center">
                <AlertCircle className="w-16 h-16 mx-auto mb-4 text-red-500" />
                <h2 className="text-2xl font-bold mb-2" style={{ color: theme.text }}>Something went wrong</h2>
                <p className="mb-6" style={{ color: theme.textSecondary }}>{error}</p>
                <Button onClick={start}>Try again</Button>
              </div>
            </CardContent>
          </Card>
        ) : (
          <div className="text-center">
            <Loader2 className="w-12 h-12 mx-auto mb-4 animate-spin" style={{ color: theme.primary }} />
            <p className="text-lg" style={{ color: theme.text }}>Preparing your assessment...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicStart;
